export const langEs = {
    welcome_back: '¡Bienvenido de nuevo!',
    enter_your_email: 'Teclea tu email',
    enter_email: 'Introduce tu email de usuario para recibir un enlace mágico.',
    get_magic_link: 'Recibir enlace mágico',
    keep_me_logged_in: 'Recuérdame',
    we_sent_you_magic_link:
        'Te hemos enviado un email con tu enlace mágico para acceder a Companio. Por favor, comprueba también tu bandeja de spam. Si sigues sin encontrarlo, <0>contáctanos</0>.',
    hello_again: "Hola de nuevo",
    welcome_to_dashboard: "Bienvenido a tu tablero",
    pending_registrations: "Inscripciones pendientes",
    employee: "Empleado",
    location: "Ubicación",
    status: "Estado",
    no_pending_registrations: "Sin registros pendientes",
    registered_employees: "Empleados registrados(masculine)",
    quote_cancel_message: "¿Estás seguro de que quieres cancelar la solicitud de empleo de EOR del cliente? Asegúrate de que el cliente ya no esté interesado en el presupuesto antes de proceder con la cancelación.",
    salary_change_requested: "Solicitud de cambio de salario",
    address: 'Dirección',
    contract_start_date: "Fecha de inicio del contrato",
    termination_date: "Fecha de finalización",
    full_name: "Nombre completo",
    company: "Empresa",
    eor_partner: "Socio EOR",
    eor_company: "Empresa EOR",
    working_hours: "Horas de trabajo/semana",
    position: "Puesto",
    work_location_mode: "Modo de ubicación de trabajo",
    work_engagement_type: "Tipo de compromiso laboral",
    pending_payrolls: "Pagos pendientes",
    notice_period: "Período de preaviso",
    payrolls_history: "Historial de nóminas",
    no_payrolls: "No se encontraron nóminas. Si ha aplicado algún filtro, es posible que desee redefinir o restablecer sus criterios para una búsqueda más precisa.",
    error_payroll_incomplete_data: "Esta nómina no tiene asociado el registro del empleado o de la empresa, por lo que no se puede abrir. Por favor, comunícaselo al equipo de desarrollo.",
};
